import React from 'react';
import {FormInline} from '../fragments/forms';
import Button from '../fragments/button';

import style from './style.css';


export default class PhyloCanvasView extends React.Component {

  constructor() {
    super(...arguments);
    const {location: {query}} = this.props;
    let availableGenes;
    if (query && query.genes) {
      availableGenes = query.genes.split(',');
    }
    this.state = {
      availableGenes,
      currentGene: null,
      tree: null
    };
  }

  componentDidMount() {
    window.addEventListener('message', ({data, origin}) => {
      if (origin !== window.location.origin) {
        return;
      }
      const {action, payload} = data;
      if (action !== 'setPhyloTreeNewick') {
        return;
      }
      this.setState({tree: payload});
    });
    const {availableGenes} = this.state;
    if (availableGenes.indexOf('RT') > -1) {
      this.handleChangeGene('RT')();
    } else {
      this.handleChangeGene('IN')();
    }
  }

  componentDidUpdate() {
    this.refs.hiddenForm.submit();
  }

  handleChangeGene(gene) {
    return () => {
      this.setState({currentGene: gene});
      window.opener.postMessage({
        action: 'setPhyloTreeGene',
        payload: gene
      }, window.location.origin);
    };
  }

  render() {
    let {availableGenes, currentGene, tree} = this.state;
    availableGenes = Array.from(availableGenes);
    return <div>
      <FormInline>
        {availableGenes.reverse().map((gene, idx) => (
          <Button
           key={idx} btnStyle="info" pullRight
           disabled={currentGene === gene}
           onClick={this.handleChangeGene(gene)}>
            {gene}
          </Button>
        ))}
      </FormInline>
      <iframe name="phylocanvas-container" className={style.iframeContainer} frameBorder="0" />
      <form
       ref="hiddenForm"
       className={style.hiddenForm}
       target="phylocanvas-container"
       action="https://phyd3.bits.vib.be/fetch.php?type=input"
       enctype="multipart/form-data"
       method="post">
        <input type="hidden" name="tree" value={tree} />
        <input type="file" name="treeFile" />
        <input type="hidden" name="annotation" />
        <input type="file" name="annotationFile" />
      </form>
    </div>;
  }

}



// WEBPACK FOOTER //
// ./src/views/phylocanvas/index.js